import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SignInSectionSignIn1 from '../components/sign-in/SignInSectionSignIn1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function SignIn() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <SignInSectionSignIn1 />
    </React.Fragment>
  );
}

